
export const getStage = (count) => {
    if (count === 0) return "Spark";
    if (count <= 5) return "Orbit";
    if (count <= 10) return "Gravity";
    if (count <= 15) return "Nova";
    return "Constellation";
};
